import { BirthdayService, BirthdayError } from '@/services/birthday.service'
import ApiService from '@/services/api.service'

const state =  {
    loading: false,
    groups: [],
    nextPage: 1,
    total: 0,
    pages: 0,
    serverResponse: null,
}

const getters = {
    loading: (state) => {
        return state.loading
    },
    groups: (state) => {
        return state.groups
    },
    nextPage: (state) => {
        return state.nextPage
    },
    total: (state) => {
        return state.total
    },
    pages: (state) => {
        return state.pages
    },
    serverResponse: (state) => {
        return state.serverResponse
    },
}

const actions = {

    async fetchGroups({ commit }, { page }) {
        commit('groupFetchAllRequest');

        try {
            const response = await BirthdayService.fetchGroups(page)

            if (response.hasOwnProperty('groups')) {
                
                commit('groupFetchAllSuccess', response)
                commit('incrementNextPage')
                
                return true
            } else {
                commit('groupFetchAllError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('groupFetchAllError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async fetchGroup({ commit }, { id }) {
        commit('groupFetchAllRequest');

        try {
            const group = await BirthdayService.fetchGroup(id)
            if (group.id > 0) {
                commit('groupReloadSuccess', group)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('groupFetchAllError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async createGroup({ commit }, { data }) { 
        commit('startRequest')
        try {
            const response = await BirthdayService.createGroup(data); 
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                let group = await BirthdayService.fetchGroup(response.id)
                if (group.id > 0) {
                    commit('groupCreateSuccess', group)
                }
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {errorCode: e.errorCode, errorMessage: e.message})
            }
            return false
        }
    },

    async updateGroup({ commit }, { data, id }) { 
        commit('startRequest')
        try {
            const response = await BirthdayService.updateGroup(data, id); 
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                data.id = id
                commit('groupUpdateSuccess', data)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }
            return false
        }
    },
    
    async deleteGroup({ commit }, { id }) {
        commit('startRequest')
        try {
            const response = await BirthdayService.deleteGroup(id);
            if (response.status === 'success') {
                commit('deleteGroupSuccess', [id])

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteMultipleGroups({ commit }, { ids }) {
        commit('startRequest')
        try {
            const response = await BirthdayService.deleteMultipleGroups(ids)
            if (response.status === 'success') {
                commit('deleteGroupSuccess', ids)

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async addContact({ commit }, { data, groupId}){
        commit('startRequest')
        try {
            const response = await BirthdayService.addContact(groupId, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                let contact = await BirthdayService.fetchContact(groupId, response.id)
                if (contact.id > 0) {
                    commit('addContactSuccess', contact)
                }
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async addContactBulk({ commit }, { data, groupId}){
        commit('startRequest')
        try {
            const response = await BirthdayService.addContactBulk(groupId, data);
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                commit('requestComplete')
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async updateContact({ commit }, { data, groupId, id}){
        commit('startRequest')
        try {
            const response = await BirthdayService.updateContact(groupId, id, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                data.groupId = groupId
                data.id = id
                commit('updateContactSuccess', data)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }
            return false
        }
    },

    async fetchGroupContacts({ commit }, { groupId, page }) {
        commit('startRequest');
        try {
            const response = await BirthdayService.fetchContacts(groupId, page)
            response.groupId = groupId
            commit('groupContactsFetchAllSuccess', response)
            commit('incrementContactNextPage', groupId)

            return true
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteContact({ commit }, { groupId, id }) {
        commit('startRequest')
        try {
            const response = await BirthdayService.deleteContact(groupId, id)
            if (response.status === 'success') {
                commit('deleteContactSuccess', {id:groupId, contactIds: [id]})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteMultipleContacts({ commit }, { groupId, ids }) {
        commit('startRequest')
        try {
            const response = await BirthdayService.deleteMultipleContacts(groupId, ids)
            if (response.status === 'success') {
                commit('deleteContactSuccess', {id:groupId, contactIds: ids})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async toggleContact({ commit }, { groupId, id }) {
        commit('startRequest')
        try {
            const response = await BirthdayService.toggleContact(groupId, id)
            if (response.status === 'success') {
                commit('toggleContactSuccess', {id:groupId, contactId: id})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async saveMessage({ commit }, { data, groupId}) {
        commit('startRequest')
        try {
            const response = await BirthdayService.saveMessage(groupId, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                let message = await BirthdayService.fetchMessage(groupId, response.id)
                if (message.id > 0) {
                    commit('addMessageSuccess', message)
                }
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async updateMessage({ commit }, { data, groupId, id}) {
        commit('startRequest')
        try {
            const response = await BirthdayService.updateMessage(groupId, id, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                data.groupId = groupId
                data.id = id
                commit('updateMessageSuccess', data)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async fetchGroupMessages({ commit }, { groupId, page }) {
        commit('startRequest')
        try {
            const response = await BirthdayService.fetchMessages(groupId, page)
            response.groupId = groupId
            commit('birthdayMessagesFetchAllSuccess', response)
            commit('incrementMessageNextPage', groupId)

            return true
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', response)
            }

            return false
        }
    },
    
    async deleteMessage({ commit }, { groupId, id }) {
        commit('startRequest')
        try {
            const response = await BirthdayService.deleteMessage(groupId, id)
            if (response.status === 'success') {
                commit('deleteMessageSuccess', {id:groupId, messageIds: [id]})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteMultipleMessages({ commit }, { groupId, ids }) {
        commit('startRequest')
        try {
            const response = await BirthdayService.deleteMultipleMessages(groupId, ids)
            if (response.status === 'success') {
                commit('deleteMessageSuccess', {id:groupId, messageIds: ids})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async toggleMessage({ commit }, { groupId, id }) {
        commit('startRequest')
        try {
            const response = await BirthdayService.toggleMessage(groupId, id);
            if (response.status === 'success') {
                commit('toggleMessageSuccess', {id:groupId, messageId: id})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof BirthdayError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
}

const mutations = {
    groupFetchAllRequest(state) {
        state.loading = true
        state.server
    },

    groupFetchAllSuccess(state, response) {
        for( let i = 0; i < response.groups.length; i++){ 
            let flag = false
            for (let j = 0; j < state.groups.length; j++) {
                if (state.groups[j].id === response.groups[i].id) {
                    flag = true
                    break
                }
            }
            if (!flag) {
                response.groups[i].marked = false                
                response.groups[i].contacts = []
                response.groups[i].contact_pages = 0
                response.groups[i].contacts_total = 0
                response.groups[i].contacts_next_page = 1
                response.groups[i].messages = []
                response.groups[i].message_pages = 0
                response.groups[i].messages_total = 0
                response.groups[i].messages_next_page = 1

                state.groups.push(response.groups[i])  
            }
        }
        state.total = response.total
        state.pages = response.pages
        state.loading = false
    },

    groupReloadSuccess(state, group) {
        group.contacts = []
        group.messages = []
        group.marked = false
        group.contact_pages = 0
        group.contacts_total = 0
        group.contacts_next_page = 1
        group.message_pages = 0
        group.messages_total = 0
        group.messages_next_page = 1

        for( let i = 0; i < state.groups.length; i++){ 
            if ( state.groups[i].id === group.id) {
                state.groups[i] = group
                break;
            }
         }
        state.loading = false
    },

    groupFetchAllError(state, response) {
        state.authenticating = false
        state.serverResponse = response
    },

    incrementNextPage(state){
        state.nextPage++
    },

    startRequest(){
       state.loading = true; 
    },

    requestComplete(state, response) {
        state.loading = false;
        state.serverResponse = response
    },

    requestError(state, response){
        state.loading = false
        state.serverResponse = response
    },

    groupCreateSuccess(state, group) {
        state.loading = false;
        group.contacts = []
        group.messages = []
        group.marked = false
        group.contact_pages = 0
        group.contacts_total = 0
        group.contacts_next_page = 1
        group.message_pages = 0
        group.messages_total = 0
        group.messages_next_page = 1

        state.groups.unshift(group)
        state.total++
    },

    groupUpdateSuccess(state, group) {
        for( let i = 0; i < state.groups.length; i++){ 
            if ( state.groups[i].id === group.id) {
                state.groups[i].name = group.name
                state.groups[i].description = group.description
                state.groups[i].time_zone_id = group.time_zone_id
                state.groups[i].delivery_time = group.delivery_time
                state.groups[i].third_party_id = group.third_party_id
                state.groups[i].template_id = group.template_id
                break
            }
        } 
        
        state.loading = false
    },

    deleteGroupSuccess(state, ids) {
        for (let h = 0; h < ids.length; h++) {
            for( let i = 0; i < state.groups.length; i++){ 
                if ( state.groups[i].id === ids[h]) {
                    state.groups.splice(i, 1)
                    state.total--
                    i--
                    break
                }
            }            
        }
        
        state.loading = false
    },

    addContactSuccess(state, contact) {
        for( let i = 0; i < state.groups.length; i++) { 
            if ( state.groups[i].id === contact.group_id) {
                state.groups[i].contacts.unshift(contact) 
                state.groups[i].contacts_total++
                break;
            }
         }
        state.loading = false
    },

    updateContactSuccess(state, data) {
        for (let h = 0; h < state.groups.length; h++) {
            if (state.groups[h].id == data.groupId) {
                for( let i = 0; i < state.groups[h].contacts.length; i++){   
                    if ( state.groups[h].contacts[i].id === data.id) {
                        state.groups[h].contacts[i].name = data.name
                        state.groups[h].contacts[i].phone_no = data.phone_no
                        state.groups[h].contacts[i].day = data.day
                        state.groups[h].contacts[i].month_id = data.month_id
                        
                        state.loading = false
                        return
                    } 
                }   
            }        
        }
        
        state.loading = false
    },

    groupContactsFetchAllSuccess(state, response)
    {
        for (let i = 0; i < state.groups.length; i++) {
            if (state.groups[i].id === response.groupId) {
                for (let j = 0; j < response.contacts.length; j++) {
                    state.groups[i].contacts_total++
                    state.groups[i].contacts.push(response.contacts[j])
                }
                state.groups[i].contact_pages = response.pages
                break
            }
        }
        state.loading = false;
    },

    deleteContactSuccess(state, group) {
        for (let h = 0; h < state.groups.length; h++) {
            if (state.groups[h].id == group.id) {
                for (let i = 0; i < group.contactIds.length; i++) {
                    for( let j = 0; j < state.groups[h].contacts.length; j++){   
                        if ( state.groups[h].contacts[j].id === group.contactIds[i]) {
                            state.groups[h].contacts.splice(j, 1)
                            state.groups[h].contacts_total--
                            j--
                            break
                        } 
                    }
                }    
            }        
        }
        
        state.loading = false
    },

    toggleContactSuccess(state, group) {
        for (let h = 0; h < state.groups.length; h++) {
            if (state.groups[h].id == group.id) {
                for( let j = 0; j < state.groups[h].contacts.length; j++){   
                    if ( state.groups[h].contacts[j].id === group.contactId) {
                        state.groups[h].contacts[j].paused = !state.groups[h].contacts[j].paused
                        break
                    } 
                }   
            }        
        }
        
        state.loading = false
    },

    addMessageSuccess(state, message) {
        for( let i = 0; i < state.groups.length; i++) { 
            if ( state.groups[i].id === message.group_id) {
                state.groups[i].messages.push(message) 
                state.groups[i].messages_total++
                break;
            }
         }
        state.loading = false
    },

    updateMessageSuccess(state, data) {
        for (let h = 0; h < state.groups.length; h++) {
            if (state.groups[h].id == data.groupId) {
                for( let i = 0; i < state.groups[h].messages.length; i++){   
                    if ( state.groups[h].messages[i].id === data.id) {
                        state.groups[h].messages[i].sender = data.sender
                        state.groups[h].messages[i].message = data.message

                        state.loading = false
                        return
                    } 
                }   
            }        
        }
        
        state.loading = false
    },

    birthdayMessagesFetchAllSuccess(state, response) {
        for (let i = 0; i < state.groups.length; i++) {
            if (state.groups[i].id === response.groupId) {
                for (let j = 0; j < response.messages.length; j++) {
                    state.groups[i].messages_total++
                    state.groups[i].messages.push(response.messages[j])
                }
                state.groups[i].message_pages = response.pages
                break
            }
        }
        state.loading = false;
    },

    deleteMessageSuccess(state, group) {
        for (let h = 0; h < state.groups.length; h++) {
            if (state.groups[h].id == group.id) {
                for (let i = 0; i < group.messageIds.length; i++) {
                    for( let j = 0; j < state.groups[h].messages.length; j++) {   
                        if ( state.groups[h].messages[j].id === group.messageIds[i]) {
                            state.groups[h].messages.splice(j, 1)
                            state.groups[h].messages_total--
                            j--
                            break
                        } 
                    }
                }    
            }        
        }
        
        state.loading = false
    },

    toggleMessageSuccess(state, group) {
        for (let h = 0; h < state.groups.length; h++) {
            if (state.groups[h].id == group.id) {
                for( let j = 0; j < state.groups[h].messages.length; j++){   
                    if ( state.groups[h].messages[j].id === group.messageId) {
                        state.groups[h].messages[j].paused = !state.groups[h].messages[j].paused
                        break
                    } 
                }   
            }        
        }
        
        state.loading = false
    },

    incrementContactNextPage(state, groupId) {
        for (let h = 0; h < state.groups.length; h++) {
            if (state.groups[h].id == groupId) {
                state.groups[h].contacts_next_page++
                break 
            }
        }    
    },

    incrementMessageNextPage(state, groupId) {
        for (let h = 0; h < state.groups.length; h++) {
            if (state.groups[h].id == groupId) {
                state.groups[h].messages_next_page++
                break
            }
        } 
    }
}

export const birthday = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}